
export const toggleJira = (opacity) => {
    const interval = setInterval(
        () => {
            let widget = document.getElementById("jsd-widget");
            if (widget) {
                widget.style.opacity = opacity;
                widget.style.top = '0px';
                clearInterval(interval)
            }
        },
        200
    );
}

export const createWidget = (key) => {
    const jiraScriptTag = document.createElement("script");
    jiraScriptTag.id = 'jira-script-tag';
    jiraScriptTag.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com');
    jiraScriptTag.setAttribute('data-jsd-embedded', true);
    jiraScriptTag.setAttribute('data-key', key);
    jiraScriptTag.src = 'https://jsd-widget.atlassian.com/assets/embed.js';
    document.body.appendChild(jiraScriptTag);
    window.document.dispatchEvent(new Event("DOMContentLoaded", {
        bubbles: true,
        cancelable: true
    }));
    toggleJira(0);
}